module.exports = __webpack_public_path__ + "img/symbol_8.b5dc8574.png";